<template>
  <div>
    <!-- La pantalla tiene un título y el resto del contenido -->
    <!-- El resto del contenido esta compuesto por dos partes: -->
    <!-- La primera parte son dos columnas de HmiLabels y HmiButtons a los que llamamos "pack" -->
    <!-- Cada pack tiene un numero de filas. El primer pack tiene 3 y el segundo tiene 4 -->
    <!-- La segunda parte esta compuesto por 2 filas de HmiLabels y HmiButtons -->
    <h1 class="title">PANTALLA {{ numeroPantalla }} COMPUERTA CANAL</h1>
    <HmiPantalla>
      <div class="content">
        <div class="screen-title">
          <HmiLabel label="COMPUERTA CANAL" width="100%" height="100%" :size="4" color="cyan" border="solid 6px yellow">
          </HmiLabel>
        </div>
        <div class="grid">
          <div class="pack">
            <div class="grid-row">
              <HmiLabel class="grid-item" label="MANUAL REMOTO" width="100%" height="100%" :size="1.7" :color="manualRemoto == '1' ? 'yellow' : '#C0FFFF'
                "></HmiLabel>
              <HmiButton class="grid-item" label="FUNCION MANUAL" width="100%" height="100%" :size="1.7"
                :color="funcionManual == '1' ? 'yellow' : 'silver'"
                @click.native=" escrituraAlternaHR(direccionVariablesBit.FUNCION_MANUAL_ESCRITURA, funcionManual)">
              </HmiButton>
            </div>
            <div class="grid-row">
              <HmiLabel class="grid-item" label="ABIERTA" width="100%" height="100%" :size="1.7"
                :color="abierta == '1' ? 'yellow' : '#C0FFFF'" :active="pilotoAbierta"></HmiLabel>
              <HmiButton class="grid-item" label="ABRIR" width="100%" height="100%" :size="1.7"
                :color="abrir == '1' ? 'yellow' : 'silver'"
                @touchstart.native.prevent="escrituraMomentaneaHR(direccionVariablesBit.ABRIR_ESCRITURA, '1')"
                @touchend.native.prevent="escrituraMomentaneaHR(direccionVariablesBit.ABRIR_ESCRITURA, '0')"
                @mousedown.native="escrituraMomentaneaHR(direccionVariablesBit.ABRIR_ESCRITURA, '1')"
                @mouseup.native="escrituraMomentaneaHR(direccionVariablesBit.ABRIR_ESCRITURA, '0')">
              </HmiButton>
            </div>
            <div class="grid-row">
              <HmiLabel class="grid-item" label="CERRADA" width="100%" height="100%" :size="1.7" :color="cerrada == '1' ? 'yellow' : '#C0FFFF'
                " :active="pilotoCerrada"></HmiLabel>
              <HmiButton class="grid-item" label="CERRAR" width="100%" height="100%" :size="1.7"
                :color="cerrar == '1' ? 'yellow' : 'silver'"
                @touchstart.native.prevent="escrituraMomentaneaHR(direccionVariablesBit.CERRAR_ESCRITURA, '1')"
                @touchend.native.prevent="escrituraMomentaneaHR(direccionVariablesBit.CERRAR_ESCRITURA, '0')"
                @mousedown.native="escrituraMomentaneaHR(direccionVariablesBit.CERRAR_ESCRITURA, '1')"
                @mouseup.native="escrituraMomentaneaHR(direccionVariablesBit.CERRAR_ESCRITURA, '0')">
              </HmiButton>
            </div>
          </div>
          <div class="pack">
            <div class="grid-row2">
              <HmiLabel class="grid-item" label="NIVEL COMPUERTA" width="100%" height="100%" :size="1.7" color="cyan">
              </HmiLabel>
              <HmiLabel class="grid-item" :label="formato3digitos(nivelCompuerta) + ' cm.'" width="100%" height="100%"
                :size="1.7" color="#C0C000"></HmiLabel>
            </div>
            <div class="grid-row2">
              <HmiLabel class="grid-item" label="CAUDAL ECOLOGICO" width="100%" height="100%" :size="1.7" color="cyan">
              </HmiLabel>
              <HmiLabel class="grid-item" :label="formato3digitos(caudalEcologico)" width="100%" height="100%" :size="1.7"
                color="#56FF56" :editable="true"
                @input="escrituraDM($event, direccionVariables.CAUDAL_ECOLOGICO_ESCRITURA, 1)"></HmiLabel>
            </div>
            <div class="grid-row2">
              <HmiLabel class="grid-item" label="NIVEL MAXIMO EN CAMARA" width="100%" height="100%" :size="1.7"
                color="cyan"></HmiLabel>
              <HmiLabel class="grid-item" :label="formato3digitos(nivelMaxCamara)" width="100%" height="100%" :size="1.7"
                color="#56FF56" :editable="true"
                @input="escrituraDM($event, direccionVariables.NIVEL_MAX_CAMARA_ESCRITURA, 1)"></HmiLabel>
            </div>
            <div class="grid-row2">
              <HmiLabel class="grid-item" label="DIFERENCIAL REGULACION" width="100%" height="100%" :size="1.7"
                color="cyan"></HmiLabel>
              <HmiLabel class="grid-item" :label="formato1digitos(diferencialRegulacion)" width="100%" height="100%"
                :size="1.7" color="#56FF56" :editable="true"
                @input="escrituraDM($event, direccionVariables.DIFERENCIAL_REGULACION_ESCRITURA, 1)"></HmiLabel>
            </div>
          </div>
        </div>
        <div class="grid2">
          <div class="grid-row3">
            <HmiLabel class="grid-item" label="TIEMPO DETECCION NIVEL d/seg." width="100%" height="100%" :size="1.7"
              color="cyan"></HmiLabel>
            <HmiLabel class="grid-item" label="TIEMPO ACCION NIVEL d/seg." width="100%" height="100%" :size="1.7"
              color="cyan"></HmiLabel>
            <HmiLabel class="grid-item" :label="formato3digitos(tiempoAccion)" width="100%" height="100%" :size="1.7"
              color="#56FF56" :editable="true"
              @input="escrituraDM($event, direccionVariables.TIEMPO_ACCION_ESCRITURA, 1)"></HmiLabel>
            <HmiLabel class="grid-item" label="ANOMALIA" width="100%" height="100%" :size="1.7"
              :color="anomalia == '1' ? 'red' : '#a3ffff'">
            </HmiLabel>
          </div>
          <div class="grid-row3">
            <HmiLabel class="grid-item" :label="formato3digitos(tiempoDeteccionNivel)" width="100%" height="100%"
              :size="1.7" color="#56FF56" :editable="true"
              @input="escrituraDM($event, direccionVariables.TIEMPO_DETECCION_NIVEL_ESCRITURA, 1)"></HmiLabel>
            <HmiLabel class="grid-item" label="TIEMPO ESPERA d/seg." width="100%" height="100%" :size="1.7" color="cyan">
            </HmiLabel>
            <HmiLabel class="grid-item" :label="tiempoEspera" width="100%" height="100%" :size="1.7" color="#56FF56"
              :editable="true" @input="escrituraDM($event, direccionVariables.TIEMPO_ESPERA_ESCRITURA, 1)"></HmiLabel>
            <HmiButton class="grid-item" label="SALIR" width="100%" height="100%" :size="1.7" color="silver"
              @click.native="navigateToMenu"></HmiButton>
          </div>
        </div>
      </div>
    </HmiPantalla>
  </div>
</template>

<script>
import HmiLabel from "@/components/HMI/HmiLabel.vue";
import HmiButton from "@/components/HMI/HmiButton.vue";
import HmiPantalla from "@/components/HMI/HmiPantalla.vue";
export default {
  name: "CompuertaPantalla",
  computed: {
    // Obtenemos el numero de pantalla en la que estamos trabajandos
    numeroPantalla() {
      return this.$route.params.numeroPantalla;
    },
    direccionVariables() {
      return {
        NIVEL_COMPUERTA_LECTURA: 37, // Correspondiente a Dm84
        CAUDAL_ECOLOGICO_LECTURA: 0, // Correspondiente a Dm148
        CAUDAL_ECOLOGICO_ESCRITURA: "Dm0148", // Correspondiente a Dm148
        NIVEL_MAX_CAMARA_LECTURA: 50, // Correspondiente a Dm154
        NIVEL_MAX_CAMARA_ESCRITURA: "Dm0154", // Correspondiente a Dm154
        DIFERENCIAL_REGULACION_LECTURA: 74, // Correspondiente a Dm149
        DIFERENCIAL_REGULACION_ESCRITURA: "Dm0149", // Correspondiente a Dm149
        TIEMPO_DETECCION_NIVEL_LECTURA: 123, // Correspondiente a Dm151
        TIEMPO_DETECCION_NIVEL_ESCRITURA: "Dm0151", // Correspondiente a Dm151
        TIEMPO_ACCION_LECTURA: 124, // Correspondiente a Dm152
        TIEMPO_ACCION_ESCRITURA: "Dm0152", // Correspondiente a Dm152
        TIEMPO_ESPERA_LECTURA: 125, // Correspondiente a Dm153
        TIEMPO_ESPERA_ESCRITURA: "Dm0153", // Correspondiente a Dm153
      };
    },
    direccionVariablesBit() {
      return {
        MANUAL_REMOTO_LECTURA: [142, 6], // Correspondiente a 4.03
        FUNCION_MANUAL_LECTURA: [142, 7], // Correspondiente a h29.13
        FUNCION_MANUAL_ESCRITURA: ["Hr0029", 13], // Correspondiente a h29.13
        ABIERTA_LECTURA: [142, 8], // Correspondiente a 4.05
        PILOTO_ABIERTA_LECTURA: [142, 9], //Correspondiente a 102.01
        ABRIR_LECTURA: [142, 10], //Correspondiente a 29.14
        ABRIR_ESCRITURA: ["Ir0029", 14], //Correspondiente a 29.14
        CERRADA_LECTURA: [142, 11], // Correspondiente a 4.06
        PILOTO_CERRADA_LECTURA: [142, 12], //Correspondiente a 102.02
        CERRAR_LECTURA: [142, 13], //Correspondiente a 29.15
        CERRAR_ESCRITURA: ['Ir0029', 15], //Correspondiente a 29.15
        ANOMALIA_LECTURA: [142, 14], //Correspondiente a 4.02
      };
    },

    nivelCompuerta() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.NIVEL_COMPUERTA_LECTURA
        ];
      }
      return "0000";
    },
    caudalEcologico() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.CAUDAL_ECOLOGICO_LECTURA
        ];
      }
      return "0000";
    },
    nivelMaxCamara() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.NIVEL_MAX_CAMARA_LECTURA
        ];
      }
      return "0000";
    },
    diferencialRegulacion() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.DIFERENCIAL_REGULACION_LECTURA
        ];
      }
      return "0000";
    },
    tiempoDeteccionNivel() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.TIEMPO_DETECCION_NIVEL_LECTURA
        ];
      }
      return "0000";
    },
    tiempoAccion() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.TIEMPO_ACCION_LECTURA
        ];
      }
      return "0000";
    },
    tiempoEspera() {
      if (this.direccionVariables) {
        return this.$store.state.lecturas[
          this.direccionVariables.TIEMPO_ESPERA_LECTURA
        ];
      }
      return "0000";
    },
    manualRemoto() {
      if (this.direccionVariablesBit) {
        let word =
          this.$store.state.lecturas[
          this.direccionVariablesBit.MANUAL_REMOTO_LECTURA[0]
          ];
        return this.obtenerBit(
          word,
          this.direccionVariablesBit.MANUAL_REMOTO_LECTURA[1]
        );
      }
      return "0";
    },
    funcionManual() {
      if (this.direccionVariablesBit) {
        let word =
          this.$store.state.lecturas[
          this.direccionVariablesBit.FUNCION_MANUAL_LECTURA[0]
          ];
        return this.obtenerBit(
          word,
          this.direccionVariablesBit.FUNCION_MANUAL_LECTURA[1]
        );
      }
      return "0";
    },
    abierta() {
      if (this.direccionVariablesBit) {
        let word =
          this.$store.state.lecturas[
          this.direccionVariablesBit.ABIERTA_LECTURA[0]
          ];
        return this.obtenerBit(
          word,
          this.direccionVariablesBit.ABIERTA_LECTURA[1]
        );
      }
      return "0";
    },
    pilotoAbierta() {
      if (this.direccionVariablesBit) {
        let word =
          this.$store.state.lecturas[
          this.direccionVariablesBit.PILOTO_ABIERTA_LECTURA[0]
          ];
        return this.obtenerBit(
          word,
          this.direccionVariablesBit.PILOTO_ABIERTA_LECTURA[1]
        );
      }
      return "0";
    },
    abrir() {
      if (this.direccionVariablesBit) {
        let word =
          this.$store.state.lecturas[
          this.direccionVariablesBit.ABRIR_LECTURA[0]
          ];
        return this.obtenerBit(
          word,
          this.direccionVariablesBit.ABRIR_LECTURA[1]
        );
      }
      return "0";
    },
    cerrada() {
      if (this.direccionVariablesBit) {
        let word =
          this.$store.state.lecturas[
          this.direccionVariablesBit.CERRADA_LECTURA[0]
          ];
        return this.obtenerBit(
          word,
          this.direccionVariablesBit.CERRADA_LECTURA[1]
        );
      }
      return "0";
    },
    pilotoCerrada() {
      if (this.direccionVariablesBit) {
        let word =
          this.$store.state.lecturas[
          this.direccionVariablesBit.PILOTO_CERRADA_LECTURA[0]
          ];
        return this.obtenerBit(
          word,
          this.direccionVariablesBit.PILOTO_CERRADA_LECTURA[1]
        );
      }
      return "0";
    },
    cerrar() {
      if (this.direccionVariablesBit) {
        let word =
          this.$store.state.lecturas[
          this.direccionVariablesBit.CERRAR_LECTURA[0]
          ];
        return this.obtenerBit(
          word,
          this.direccionVariablesBit.CERRAR_LECTURA[1]
        );
      }
      return "0";
    },
    anomalia() {
      if (this.direccionVariablesBit) {
        let word =
          this.$store.state.lecturas[
          this.direccionVariablesBit.ANOMALIA_LECTURA[0]
          ];
        return this.obtenerBit(
          word,
          this.direccionVariablesBit.ANOMALIA_LECTURA[1]
        );
      }
      return "0";
    },
  },
  components: {
    HmiLabel,
    HmiButton,
    HmiPantalla,
  },
  methods: {
    // Navegación a "Menu"
    navigateToMenu() {
      this.$router.push(`/pantalla/${this.numeroPantalla}`);
    },

    // Emitir evento salida
    mandarSalida() {
      this.$emit("mandar-pagina", "pagina/salida", "7", "");
    },

    // Emitir evento entrada
    mandarEntrada() {
      this.$emit("mandar-pagina", "pagina/entrada", "7", "");
    },

    //Formatear cm
    formato3digitos(dato) {
      dato = dato.substring(1, 4);
      return dato;
    },

    formato2digitos(dato) {
      dato = dato.substring(2, 4);
      return dato;
    },

    formato1digitos(dato) {
      dato = dato.substring(3, 4);
      return dato;
    },

    //Obtener bit
    obtenerBit(dato, posicion) {
      let intValue = parseInt(dato, 16);

      let binaryString = intValue.toString(2).padStart(16, "0");

      let bit = binaryString.charAt(binaryString.length - 1 - posicion);
      return bit;
    },

    escrituraDM(value, direccion, canales) {
      direccion = direccion.substring(2);
      const payload = {
        name: "escrituraDM",
        direccion: direccion,
        valor: value.padStart(4 * canales, "0"),
      };
      this.$emit("mandar-escritura", payload);
    },

    escrituraAlternaHR(direccionEscritura, valor) {

      // Determinar la dirección y el número de bit desde direccionEscritura
      let direccion = direccionEscritura[0].substring(2);
      let bit = direccionEscritura[1];

      const nuevoValor = valor == "0" ? "1" : "0";

      // Construir el payload con el nuevo valor hexadecimal
      const payload = {
        name: "escrituraHR",
        direccion: direccion,
        valor: nuevoValor,
        bit: bit,
      };

      // Emitir el nuevo payload
      this.$emit("mandar-escritura", payload);
    },

    escrituraMomentaneaHR(direccionEscritura, valor) {

      // Determinar la dirección y el número de bit desde direccionEscritura
      let direccion = direccionEscritura[0].substring(2);
      let bit = direccionEscritura[1];

      // Construir el payload con el nuevo valor hexadecimal
      const payload = {
        name: "escrituraIR",
        direccion: direccion,
        valor: valor,
        bit: bit,
      };
      console.log(payload)
      // Emitir el nuevo payload
      this.$emit("mandar-escritura", payload);
    },
  },
  mounted() {
    //Mandar a nodered entrada
    this.mandarEntrada();
    //Cuando se cierre la ventana enviar señal
    window.addEventListener("unload", this.mandarSalida);
  },
  destroyed() {
    //Mandar a nodered salida
    this.mandarSalida();
  },
};
</script>

<style scoped>
.title {
  font-family: "Courier New", Courier, monospace !important;
  text-align: center;
  margin: 20px 20px 0px 20px;
}

.content {
  height: 100%;
}

.screen-title {
  display: flex;
  justify-content: center;
  height: 15%;
}

.grid {
  height: 55%;
  display: flex;
  flex-direction: row;
  gap: clamp(1px, 1.5vw, 30px);
}

.grid2 {
  height: 30%;
  gap: clamp(1px, 1vw, 20px);
}

.grid-row {
  padding-top: clamp(1px, 2vw, 20px);
  height: 33%;
  gap: clamp(1px, 1vw, 20px);
  display: flex;
  justify-content: space-between;
}

.grid-row2 {
  padding-top: clamp(1px, 2vw, 20px);
  height: 25%;
  gap: clamp(1px, 1vw, 20px);
  display: flex;
  justify-content: space-between;
}

.grid-row3 {
  padding-top: clamp(1px, 2vw, 20px);
  height: 50%;
  gap: clamp(1px, 1vw, 20px);
  display: flex;
  justify-content: space-between;
}

.pack {
  height: 100%;
  width: 50%;
}
</style>
